import WorldPopCounter from './WorldPopCounter';

const worldPopCounterConfig = {
  name: 'worldPopCounter',
  class: WorldPopCounter,
  querySelector: {
    counter: '.featured-module__counter-number',
  },
};

export default worldPopCounterConfig;



// WEBPACK FOOTER //
// ./client/js/components/WorldPopCounter/worldPopCounterConfig.js